module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/2-1-7e09ce6b6750f8348b593ef2d8e8e0bf.png";